import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface Peca { id: string; nome: string; hash: string; paginas: number; assinado: boolean; tipo: string; }
interface Versao { versao: number; paginas: number; criadoEm: string; usuarioId: number; }
interface Estado { pecas: Peca[]; versoes: Versao[]; }

@Component({
  selector: 'app-saneamento-processo', standalone: true, imports: [CommonModule, FormsModule],
  templateUrl: './saneamento-processo.component.html',
  styles: [`:host{display:block;padding:1.5rem} .acoes{display:flex;gap:.75rem;flex-wrap:wrap;margin:1rem 0} table{width:100%;border-collapse:collapse} th,td{text-align:left;padding:.6rem;border-bottom:1px solid #ddd} button,input{padding:.5rem} .erro{color:#a31717} label{display:inline-flex;gap:.5rem;align-items:center;margin-right:1rem}`]
})
export class SaneamentoProcessoComponent implements OnChanges {
  @Input({ required: true }) idBeneficio!: number;
  estado: Estado = { pecas: [], versoes: [] };
  carregando = false;
  erro = '';
  mensagem = '';
  versaoHistorica: number | null = null;
  pecasHistoricas: Array<Peca & { paginaInicial: number }> = [];
  constructor(private http: HttpClient) {}
  private get url(): string { return `${environment.URL_API}/processo/${this.idBeneficio}/saneamento`; }
  ngOnChanges(): void { this.versaoHistorica = null; this.pecasHistoricas = []; this.estado = { pecas: [], versoes: [] }; if (this.idBeneficio) void this.carregar(); }

  async carregar(): Promise<void> {
    this.carregando = true; this.erro = '';
    const beneficio = this.idBeneficio;
    try { const estado = await firstValueFrom(this.http.get<Estado>(this.url)); if (beneficio === this.idBeneficio) this.estado = estado; }
    catch (error) { this.falha(error); }
    finally { this.carregando = false; }
  }
  async gerar(tipo: string): Promise<void> {
    this.carregando = true; this.erro = ''; this.mensagem = '';
    try {
      await firstValueFrom(this.http.post<Peca>(`${this.url}/gerar`, { tipo }));
      await this.carregar();
      this.mensagem = 'Documento gerado e salvo. Confira as peças e a ordem antes de montar o processo.';
    } catch (error) { this.falha(error); }
    finally { this.carregando = false; }
  }
  mover(index: number, delta: number): void {
    const destino = index + delta;
    if (this.carregando || destino < 0 || destino >= this.estado.pecas.length) return;
    const pecas = [...this.estado.pecas];
    [pecas[index], pecas[destino]] = [pecas[destino], pecas[index]];
    this.estado = { ...this.estado, pecas };
  }
  async ordenar(): Promise<void> {
    this.carregando = true; this.erro = ''; this.mensagem = '';
    try {
      const versao = await firstValueFrom(this.http.post<Versao>(`${this.url}/ordenar`, {
        ordem: this.estado.pecas.map(p => p.id), versaoAtual: this.estado.versoes[0]?.versao ?? 0
      }));
      await this.carregar(); this.mensagem = `Versão ${versao.versao} salva, com ${versao.paginas} páginas.`;
    } catch (error) { this.falha(error); }
    finally { this.carregando = false; }
  }
  async baixarPeca(peca: Peca): Promise<void> {
    try { this.salvar(await firstValueFrom(this.http.get(`${this.url}/pecas/${encodeURIComponent(peca.id)}/pdf`, { responseType: 'blob' })), `${peca.tipo.toLowerCase()}.pdf`); }
    catch (error) { this.falha(error); }
  }
  async baixarVersao(versao: number): Promise<void> {
    try { this.salvar(await firstValueFrom(this.http.get(`${this.url}/versoes/${versao}/pdf`, { responseType: 'blob' })), `processo-${this.idBeneficio}-v${versao}.pdf`); }
    catch (error) { this.falha(error); }
  }
  async verPecas(versao: number): Promise<void> {
    const beneficio = this.idBeneficio;
    try {
      const pecas = await firstValueFrom(this.http.get<Array<Peca & { paginaInicial: number }>>(`${this.url}/versoes/${versao}/manifesto`));
      if (beneficio === this.idBeneficio) { this.pecasHistoricas = pecas; this.versaoHistorica = versao; }
    } catch (error) { this.falha(error); }
  }
  async baixarPecaHistorica(indice: number): Promise<void> {
    if (this.versaoHistorica === null) return;
    try {
      this.salvar(await firstValueFrom(this.http.get(`${this.url}/versoes/${this.versaoHistorica}/pecas/${indice}/pdf`, { responseType: 'blob' })), `peca-${indice + 1}-v${this.versaoHistorica}.pdf`);
    } catch (error) { this.falha(error); }
  }
  private salvar(blob: Blob, nome: string): void {
    const url = URL.createObjectURL(blob); const link = document.createElement('a');
    link.href = url; link.download = nome; link.click(); setTimeout(() => URL.revokeObjectURL(url), 60000);
  }
  private falha(error: any): void {
    this.erro = typeof error?.error?.message === 'string' ? error.error.message : 'Não foi possível concluir a operação. Confira a sessão e tente novamente.';
  }
}
